export function formatEnergy(value) {
  if (value >= 1000000) {
    return (value / 1000000).toFixed(3) + " GWh";
  } else if (value >= 1000) {
    return (value / 1000).toFixed(3) + " MWh";
  } else {
    return value + " kWh";
  }
}

export function formatPowerVal(value) {
  return parseFloat(value.toFixed(3));
}

export function formatEnergyVal(value) {
  return parseFloat(value.toFixed(0));
}
